import { App } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Tooltip from 'primevue/tooltip';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Divider from 'primevue/divider';
import Card from 'primevue/card';
import SelectButton from 'primevue/selectbutton';
import RadioButton from 'primevue/radiobutton';
import ToggleButton from 'primevue/togglebutton';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Checkbox from 'primevue/checkbox';
import Carousel from 'primevue/carousel';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ToastService from 'primevue/toastservice';
import Textarea from 'primevue/textarea';
import ProgressSpinner from 'primevue/progressspinner';
import InputSwitch from 'primevue/inputswitch';
import Slider from 'primevue/slider';
import Message from 'primevue/message';
import Calendar from 'primevue/calendar';
import Locale from 'primevue/config';
import Password from 'primevue/password';

const configPrimeVue = (app: App) => {
  app.component('Dialog', Dialog);
  app.component('Button', Button);
  app.component('Dropdown', Dropdown);
  app.component('InputText', InputText);
  app.component('InputNumber', InputNumber);
  app.component('Divider', Divider);
  app.component('Card', Card);
  app.component('SelectButton', SelectButton);
  app.component('RadioButton', RadioButton);
  app.component('ToggleButton', ToggleButton);
  app.component('Accordion', Accordion);
  app.component('AccordionTab', AccordionTab);
  app.component('Checkbox', Checkbox);
  app.component('Carousel', Carousel);
  app.component('TabView', TabView);
  app.component('TabPanel', TabPanel);
  app.component('Textarea', Textarea);
  app.component('ProgressSpinner', ProgressSpinner);
  app.component('InputSwitch', InputSwitch);
  app.component('Slider', Slider);
  app.component('Message', Message);
  app.component('Calendar', Calendar);
  app.component('Password', Password);

  app.directive('Tooltip', Tooltip);
  app.use(ToastService);
  app.use(Locale);
};

export default configPrimeVue;
